import React, { useRef } from "react";
import { useHistory } from "react-router-dom";

import ReactToPrint from "react-to-print";
// import prettier from "prettier";

import { Paper } from "@material-ui/core";

import {
  Button,
  Loading,
  Show,
  SimpleShowLayout,
  TopToolbar,
  useNotify,
  useShowController,
} from "react-admin";

import { getBackPath, shallowRedirect } from "../../../utils/utils";

import { EditIcon, PrintIcon } from "../../../components/common/iconography";
import { BackButton } from "../../../components/common/BackButton";

import { MarkPaidButton } from "./MarkPaidButtons";
import { ReopenButton } from "./ReopenButton";
import { PrintableInvoiceBlock } from "./PrintableInvoiceBlock";
import { SendInvoiceButton } from "./SendInvoiceButtons";

export const EmailInvoiceBody = ({ record, encloseAttachments, ...props }) => {
  return (
    <Paper elevation={0} style={{ maxWidth: "800px", margin: "auto" }}>
      <PrintableInvoiceBlock
        record={record}
        encloseAttachments={encloseAttachments}
        {...props}
      />
    </Paper>
  );
};

class PrintableInvoice extends React.PureComponent {
  render() {
    const { record, ...props } = this.props;
    return <PrintableInvoiceBlock record={record} {...props} />;
  }
}

const InvoiceActions = ({ record, backPath, invRef, ...props }) => {
  const history = useHistory();

  const handleEdit = () => {
    shallowRedirect(history, `/invoices/${props.data.id}`, backPath, {});
  };

  return (
    <TopToolbar>
      <SendInvoiceButton {...props} record={props.data} />
      {!record.externalStatus && (
        <MarkPaidButton {...props} record={props.data} />
      )}
      {!record.externalStatus && (
        <ReopenButton {...props} record={props.data} />
      )}
      <ReactToPrint
        trigger={() => (
          <Button
            {...props}
            label="Print"
            color="primary"
            startIcon={<PrintIcon />}
          />
        )}
        content={() => invRef.current}
        documentTitle={"Transloads_Invoice"}
      />
      <Button label="Edit" onClick={handleEdit}>
        <EditIcon />
      </Button>
      <BackButton {...props} backPath={backPath} />
    </TopToolbar>
  );
};

export const InvoiceShow = (props) => {
  const notify = useNotify();
  const invRef = useRef();
  const { record, loading } = useShowController(props);
  const backPath = getBackPath(props);

  if (loading) return <Loading />;
  if (!record || !record.reloadYard) return null;
  return (
    <Show
      {...props}
      title=" "
      actions={
        <InvoiceActions
          record={record}
          backPath={backPath}
          invRef={invRef}
          notify={notify}
        />
      }
    >
      <SimpleShowLayout>
        <PrintableInvoice record={record} ref={invRef} />
      </SimpleShowLayout>
    </Show>
  );
};
